import * as angular from "angular";
import {IController, IScope} from "angular";

export class planningRoutesQueryTableItemCtrl implements IController {

  routeId: any;
  isSelected: boolean;
  show: any;
  highlighted: any;
  onToggle: Function;

  /* @ngInject */
  constructor(private $delivery, private $mdMedia, private $planningRoutes, private $scope: IScope) {
  }

  $onInit() {
    if (this.routeId) {
      this.$planningRoutes(this.routeId).$bindCtrlToId(this.$scope, this, 'route', 'routeId');
    }
  };

  $onChanges(changes) {
    if (changes.routeId && !changes.routeId.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesQueryTableItem', {
    require: {
      planningRoutesTableCtrl: '^planningRoutesQueryTable'
    },
    bindings: {
      routeId: '<',
      isSelected: '<',
      show: '<',
      highlighted: '<',
      onToggle: '&'
    },
    template: require('./planning-routes-query-table-item.html').default,
    controller: planningRoutesQueryTableItemCtrl
  });
